<template>
  <div class="card task-lane-item">
    <div class="card-block">
      <h5 class="card-title">
        <slot name="card" v-bind:item="item">
          <!-- conteúdo fallback -->
          <div>ID: {{ item.id }}</div>
          <div>SortField: {{ item.sortField }}</div>
          <!-- <div>{{ item }}</div> -->
        </slot>
      </h5>
    </div>
  </div>
</template>
        
<script>
export default {
  name: "KanbanBoardSlot",
  props: {
    item: Object,
  },
  data: function () {
    return {
      filter: "",
    };
  },
  computed: {
    todoItems() {
      return [
        { id: 1, text: "teste 1" },
        {
          id: 2,
          text: "teste 2 It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
        },
        { id: 3, text: "teste 3" },
      ];
    },
    inProgressItems() {
      return [
        { id: 4, text: "teste 4" },
        { id: 5, text: "teste 5" },
      ];
    },
    doneItems() {
      return [{ id: 6, text: "teste 6" }];
    },
  },
  methods: {
    filtredCards(tower) {
      if (!tower) return [];
      if (!tower.cards) return [];
      if (tower.cards.length == 0) return [];

      const filterToLower = this.filter.toLowerCase();
      let filtredCards = tower.cards.filter((card) => {
        return (
          card.id.toString().includes(filterToLower) ||
          card.text.toLowerCase().includes(filterToLower) ||
          card.elapsedTime.includes(filterToLower) ||
          card.checklistId?.includes(filterToLower)
        );
      });

      return filtredCards;
    },
    refreshData() {
      this.$emit("refreshData");
    },
  },
};
</script>
        
        <style scoped>
.board {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  /* height: calc(100vh - 100px); */
  height: 100%;
}

.kanban-board-card {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  min-width: 300px;
}
.file {
  background: #2c3b5d;
  width: 3rem;
  height: 100%;
  padding-top: 8px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
/* .file {
          border: 1px;
          border-color: #2b3553;
          border-style: solid;
          width: 3rem;
          height: 100%;
          margin-bottom: 1px;
          padding-top: 8px;
          padding-left: 14px;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        } */

/* width */
/* ::-webkit-scrollbar {
          height: 15px;
          width: 15px;
        } */

/* Track */
/* ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px grey; 
          border-radius: 10px;
        } */

/* Handle */
/* ::-webkit-scrollbar-thumb {
          background: #627180; 
          border-radius: 10px;
        } */

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
          background: #627180; 
        } */

/* TaskLane - Begin */
.card {
  min-height: 50px !important;
  /* width: 500px; */
  /* max-width: 400px !important;
          min-width: 300px !important; */
}
.card-body {
  overflow: auto;
  /* height: 100%; */
  /* height: calc(100vh - 270px); */
}

.task-lane {
  height: 100%;
  /* height: calc(100vh - 140px); */
  /* height: calc(100vh - 170px); */
}

/* width */
/* ::-webkit-scrollbar {
          width: 15px;
        } */

/* Track */
/* ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px grey; 
          border-radius: 10px;
        } */

/* Handle */
/* ::-webkit-scrollbar-thumb {
          background: #627180; 
          border-radius: 10px;
        } */

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
          background: #627180; 
        } */
/* TaskLane - End */
</style>